var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYesOrNoLeftSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 117,
    viewBox: "0 0 101 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.282 59.6197C82.3623 59.0046 82.3072 57.8879 82.8966 56.9988C83.1359 56.6514 83.4726 56.2812 83.837 56.0647C84.5963 55.6576 85.0836 56.197 85.3425 56.8842C85.6419 57.7098 85.6104 58.6494 85.8817 59.4775C86.1707 60.3466 86.6366 61.1291 87.2361 61.8149C87.8662 62.5263 89.1135 61.6933 88.4681 60.9689C87.8049 60.2036 87.334 59.3646 87.1325 58.3601C86.9992 57.6478 86.9633 56.9127 86.7045 56.2256C86.2628 55.0717 85.1419 54.1051 83.8373 54.4464C81.2128 55.116 79.8575 59.096 82.3178 60.7688C83.1022 61.2964 84.0817 60.1602 83.282 59.6198L83.282 59.6197Z",
    fill: "url(#paint0_linear_1698_19728)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2955 63.3643C90.9126 62.6289 89.7635 61.6647 89.1464 62.4002C88.5293 63.1356 89.6784 64.0998 90.2955 63.3643Z",
    fill: "url(#paint1_linear_1698_19728)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3311 50.1064C44.3184 49.6603 44.0702 48.5702 44.4963 47.5922C44.6717 47.2085 44.939 46.7855 45.2602 46.5091C45.9373 45.9762 46.5109 46.4228 46.8851 47.0546C47.3234 47.8157 47.4556 48.7466 47.8665 49.5149C48.302 50.3206 48.8967 51.0104 49.6062 51.5816C50.3502 52.1728 51.434 51.1358 50.6726 50.5346C49.8866 49.896 49.2771 49.1516 48.9043 48.1973C48.6493 47.5189 48.4863 46.8013 48.1121 46.1695C47.4768 45.1099 46.205 44.3526 44.9795 44.9152C42.5112 46.0305 41.8676 50.1853 44.581 51.4055C45.445 51.7889 46.2124 50.4998 45.331 50.1065L45.3311 50.1064Z",
    fill: "url(#paint2_linear_1698_19728)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8895 52.5761C53.3695 51.7447 52.0705 50.9947 51.5905 51.8261C51.1105 52.6576 52.4095 53.4076 52.8895 52.5761Z",
    fill: "url(#paint3_linear_1698_19728)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3412 28.4288C81.4785 27.7358 81.5209 26.6186 82.1856 25.7842C82.4543 25.4589 82.822 25.1195 83.2038 24.9357C83.9958 24.5962 84.4342 25.176 84.6321 25.8832C84.8585 26.7317 84.7453 27.6651 84.9433 28.5136C85.1554 29.4046 85.5514 30.2248 86.0888 30.9602C86.6545 31.7238 87.9698 31.0026 87.3899 30.2248C86.7959 29.4046 86.3999 28.5278 86.2868 27.5096C86.2161 26.7883 86.2443 26.0529 86.0464 25.3458C85.707 24.1578 84.6746 23.0972 83.3452 23.3235C80.6723 23.7619 78.9753 27.6085 81.2805 29.4894C82.0158 30.0834 83.0906 29.0369 82.3411 28.4288L82.3412 28.4288Z",
    fill: "url(#paint4_linear_1698_19728)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0014 32.7704C89.6803 32.0916 88.6196 31.0309 87.9408 31.7097C87.2619 32.3886 88.3226 33.4492 89.0014 32.7704Z",
    fill: "url(#paint5_linear_1698_19728)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.282 14.6197C44.3623 14.0046 44.3072 12.8879 44.8966 11.9988C45.1359 11.6514 45.4726 11.2812 45.837 11.0647C46.5963 10.6576 47.0836 11.197 47.3425 11.8842C47.6419 12.7098 47.6104 13.6494 47.8817 14.4775C48.1707 15.3466 48.6366 16.1291 49.2361 16.8149C49.8662 17.5263 51.1135 16.6933 50.4681 15.9689C49.8049 15.2036 49.334 14.3646 49.1325 13.3601C48.9992 12.6478 48.9633 11.9127 48.7045 11.2256C48.2628 10.0717 47.1419 9.10509 45.8373 9.44636C43.2128 10.116 41.8575 14.096 44.3178 15.7688C45.1022 16.2964 46.0817 15.1602 45.282 14.6198L45.282 14.6197Z",
    fill: "url(#paint6_linear_1698_19728)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2955 18.3643C52.9126 17.6289 51.7635 16.6647 51.1464 17.4002C50.5293 18.1356 51.6784 19.0998 52.2955 18.3643Z",
    fill: "url(#paint7_linear_1698_19728)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4671 57.5769C9.39243 57.3134 8.95872 56.2829 9.20849 55.2458C9.31457 54.8375 9.50437 54.3745 9.77271 54.0465C10.347 53.4041 10.9894 53.7444 11.4677 54.3016C12.0314 54.975 12.3232 55.8687 12.8613 56.5541C13.4301 57.2719 14.1356 57.8479 14.9335 58.2873C15.7689 58.7403 16.6561 57.5308 15.8019 57.071C14.9169 56.5786 14.1875 55.9513 13.6546 55.0763C13.2857 54.4525 13.0005 53.7741 12.5223 53.2169C11.7126 52.2836 10.3287 51.7587 9.21952 52.5256C6.98235 54.0525 7.06995 58.256 9.95407 58.9864C10.8716 59.214 11.4034 57.8113 10.4671 57.5769L10.4671 57.5769Z",
    fill: "url(#paint8_linear_1698_19728)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3394 58.6967C18.6677 57.7945 17.2582 57.2815 16.9299 58.1836C16.6015 59.0858 18.011 59.5988 18.3394 58.6967Z",
    fill: "url(#paint9_linear_1698_19728)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3893 85.3446C42.3417 84.9884 41.9994 83.9241 42.3386 82.9127C42.4799 82.5152 42.7093 82.0704 43.0052 81.7671C43.6333 81.1773 44.2436 81.5722 44.6715 82.169C45.1744 82.8889 45.3872 83.8047 45.8635 84.5343C46.3676 85.299 47.0202 85.9343 47.7768 86.4416C48.5695 86.9657 49.5588 85.8381 48.7478 85.3056C47.9092 84.7379 47.2372 84.0494 46.7826 83.1313C46.4694 82.4777 46.2445 81.777 45.8166 81.1803C45.0914 80.18 43.7585 79.5365 42.5867 80.2038C40.2249 81.5299 39.9459 85.725 42.7553 86.7041C43.6495 87.0107 44.3016 85.6597 43.3893 85.3446L43.3893 85.3446Z",
    fill: "url(#paint10_linear_1698_19728)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1325 87.1462C51.5382 86.2761 50.1788 85.6422 49.773 86.5123C49.3673 87.3824 50.7268 88.0163 51.1325 87.1462Z",
    fill: "url(#paint11_linear_1698_19728)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3311 102.106C13.3184 101.66 13.0702 100.57 13.4963 99.5922C13.6717 99.2085 13.939 98.7855 14.2602 98.5091C14.9373 97.9762 15.5109 98.4228 15.8851 99.0546C16.3234 99.8157 16.4556 100.747 16.8665 101.515C17.302 102.321 17.8967 103.01 18.6062 103.582C19.3502 104.173 20.434 103.136 19.6726 102.535C18.8866 101.896 18.2771 101.152 17.9043 100.197C17.6493 99.5189 17.4863 98.8013 17.1121 98.1695C16.4768 97.1099 15.205 96.3526 13.9795 96.9152C11.5112 98.0305 10.8676 102.185 13.581 103.405C14.445 103.789 15.2124 102.5 14.331 102.106L14.3311 102.106Z",
    fill: "url(#paint12_linear_1698_19728)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8895 104.576C22.3695 103.745 21.0705 102.995 20.5905 103.826C20.1105 104.658 21.4095 105.408 21.8895 104.576Z",
    fill: "url(#paint13_linear_1698_19728)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6818 106.017C68.5777 105.944 67.9717 105.004 68.0375 103.94C68.0711 103.519 68.1776 103.03 68.3849 102.661C68.839 101.928 69.5306 102.152 70.0984 102.618C70.7705 103.183 71.2131 104.012 71.8621 104.594C72.5469 105.202 73.3417 105.647 74.2037 105.941C75.1051 106.242 75.7688 104.897 74.8477 104.592C73.8907 104.261 73.0634 103.77 72.3867 103.001C71.915 102.45 71.5164 101.832 70.9486 101.366C69.9892 100.588 68.5352 100.311 67.576 101.259C65.638 103.151 66.4542 107.276 69.4213 107.494C70.3644 107.559 70.6446 106.085 69.6818 106.017L69.6818 106.017Z",
    fill: "url(#paint14_linear_1698_19728)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6276 105.753C77.7943 104.807 76.3171 104.547 76.1504 105.492C75.9837 106.438 77.4609 106.698 77.6276 105.753Z",
    fill: "url(#paint15_linear_1698_19728)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8075 32.9825L29.9297 31.5549L28.5021 32.6771L28 28.4846L27.4979 32.6771L26.0703 31.5549L27.1925 32.9825L23 33.4846L27.1925 33.9867L26.0703 35.4143L27.4979 34.2921L28 38.4846L28.5021 34.2921L29.9297 35.4143L28.8075 33.9867L33 33.4846L28.8075 32.9825Z",
    fill: "#827677"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0653 77.6331L74.8508 76.6338L73.8515 77.4194L73.5 74.4846L73.1485 77.4194L72.1492 76.6338L72.9347 77.6331L70 77.9846L72.9347 78.3361L72.1492 79.3354L73.1485 78.5499L73.5 81.4846L73.8515 78.5499L74.8508 79.3354L74.0653 78.3361L77 77.9846L74.0653 77.6331Z",
    fill: "#827677"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0653 7.63314L63.8508 6.63383L62.8515 7.41936L62.5 4.48462L62.1485 7.41936L61.1492 6.63383L61.9347 7.63314L59 7.98462L61.9347 8.3361L61.1492 9.33541L62.1485 8.54988L62.5 11.4846L62.8515 8.54988L63.8508 9.33541L63.0653 8.3361L66 7.98462L63.0653 7.63314Z",
    fill: "#827677"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2268 110.533L48.2367 109.248L46.9519 110.258L46.5 106.485L46.0481 110.258L44.7633 109.248L45.7732 110.533L42 110.985L45.7732 111.437L44.7633 112.721L46.0481 111.711L46.5 115.485L46.9519 111.711L48.2367 112.721L47.2268 111.437L51 110.985L47.2268 110.533Z",
    fill: "#827677"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4845 79.1834L23.1578 78.3268L22.3013 79.0001L22 76.4846L21.6987 79.0001L20.8422 78.3268L21.5155 79.1834L19 79.4846L21.5155 79.7859L20.8422 80.6424L21.6987 79.9691L22 82.4846L22.3013 79.9691L23.1578 80.6424L22.4845 79.7859L25 79.4846L22.4845 79.1834Z",
    fill: "#827677"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.646 43.0829L70.5438 41.9409L69.4017 42.8386L69 39.4846L68.5983 42.8386L67.4562 41.9409L68.354 43.0829L65 43.4846L68.354 43.8863L67.4562 45.0284L68.5983 44.1306L69 47.4846L69.4017 44.1306L70.5438 45.0284L69.646 43.8863L73 43.4846L69.646 43.0829Z",
    fill: "#827677"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4845 48.1834L96.1578 47.3268L95.3013 48.0001L95 45.4846L94.6987 48.0001L93.8422 47.3268L94.5155 48.1834L92 48.4846L94.5155 48.7859L93.8422 49.6424L94.6987 48.9691L95 51.4846L95.3013 48.9691L96.1578 49.6424L95.4845 48.7859L98 48.4846L95.4845 48.1834Z",
    fill: "#827677"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1698_19728",
    x1: 88.2011,
    y1: 66.2974,
    x2: 92.5189,
    y2: 57.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1698_19728",
    x1: 90.1172,
    y1: 64.2769,
    x2: 90.8958,
    y2: 62.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1698_19728",
    x1: 51.3349,
    y1: 55.8284,
    x2: 54.0012,
    y2: 46.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1698_19728",
    x1: 52.8724,
    y1: 53.5058,
    x2: 53.2966,
    y2: 51.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1698_19728",
    x1: 86.6595,
    y1: 35.5097,
    x2: 91.7568,
    y2: 26.7881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1698_19728",
    x1: 88.7443,
    y1: 33.6639,
    x2: 89.6919,
    y2: 31.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1698_19728",
    x1: 50.2011,
    y1: 21.2974,
    x2: 54.5189,
    y2: 12.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1698_19728",
    x1: 52.1172,
    y1: 19.2769,
    x2: 52.8958,
    y2: 17.3039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1698_19728",
    x1: 17.3734,
    y1: 62.1694,
    x2: 18.3072,
    y2: 52.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1698_19728",
    x1: 18.484,
    y1: 59.6151,
    x2: 18.5408,
    y2: 57.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1698_19728",
    x1: 49.869,
    y1: 90.5215,
    x2: 51.676,
    y2: 80.5825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1698_19728",
    x1: 51.1965,
    y1: 88.0738,
    x2: 51.4379,
    y2: 85.9666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1698_19728",
    x1: 20.3349,
    y1: 107.828,
    x2: 23.0012,
    y2: 98.0847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1698_19728",
    x1: 21.8724,
    y1: 105.506,
    x2: 22.2966,
    y2: 103.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1698_19728",
    x1: 77.2806,
    y1: 109.34,
    x2: 76.4536,
    y2: 99.2722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1698_19728",
    x1: 77.9295,
    y1: 106.632,
    x2: 77.6173,
    y2: 104.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesOrNoLeftSide);
export default __webpack_public_path__ + "static/media/yes-or-no-left-side.26b28799d84e4d9b015ecd39f542ca3c.svg";
export { ForwardRef as ReactComponent };